import React, { Component } from 'react';
import Auth from '../common/Auth'
import Config from '../Config'
import axios from 'axios'
import $ from 'jquery'

export default class CashierForm extends Component{
    constructor(props){
        super(props)

        this.auth = new Auth()
        this.config = new Config()
        this.$http = this.config.DConnect()

        this.state = {
            formItems:{
                id:0, username:'', cashlimit:0,  createdby:this.auth.getUser(),
                createdon:new Date(), curuser:this.auth.getUser(), token:this.auth.getToken()
            },
            cashiers: this.props.cashiers,
            users:[]
        }
    }

    componentDidMount(){
        this.getUsers()
    }

    componentWillReceiveProps(nextProps){
        if(nextProps !== this.props){
            let cashiers = nextProps.cahsiers;

            this.setState({ cashiers });
            this.getUsers();
        }
    }

    getUsers = () => {
        let { cashiers } = this.state;
        if(cashiers == undefined){
            return;
        }
        this.$http.get(`admin/wapp/${this.auth.getUser()}/${this.auth.getToken()}/user`)
        .then(res => {
            let resdata = this.auth.decryptData(res.data);

            //alert(JSON.stringify(resdata))
            let usernames = cashiers.map(cash => cash.username);
            let users = resdata.filter(rdata => !usernames.includes(rdata) && ![1,2,4,5,6].includes(rdata.auth) );

            this.setState({ users });
        }).catch((error)=>{alert(error)})
    }

    handleChange = (e) =>{
        let formItems = this.state.formItems;

        formItems[e.target.name] = e.target.value;

        this.setState({ formItems });
    }

    formSubmit = (e) => {
        e.preventDefault();

        let { formItems } = this.state;
        
        let formData = this.auth.encryptData(JSON.stringify(formItems))
        axios(this.config.PostOptions(formData, 'admin/wapp/cashier'))
        .then((res) => {
            if(isNaN(res.data)){
                alert(this.auth.decryptText(res.data));
                
                $('#btnCashiercancel').click();
                this.props.getReportData();
            }else{
                this.auth.doAlert(parseInt(res.data));
            }
            
        }).catch((error)=>{alert(error)});
    }

    render(){
        let { formItems, users } = this.state;
        return(
            <div className="modal fade" id="cashierform" tabindex="-1" role="dialog" aria-hidden="true">  
                <div className="modal-dialog">  
                    <div className="modal-content"> 
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true"> × </button>
                            <h5 className="modal-title">New Cashier</h5>
                        </div>
                        <div className="modal-body">
                            <form id="frmCashier" className="smart-form" onSubmit={this.formSubmit}>
                                <div className="row">
                                    <div className="col-xs-12 col-md-8">
                                        <label className="label col col-5 text-right">User: </label>
                                        <section className="col col-7">
                                            <label className="select">
                                                <select name="username" className="form-control" value={formItems.username} onChange={this.handleChange} style={{height:'32px',width:'180px'}}>
                                                    <option value="">-- Select User --</option>
                                                    {users!==undefined && users.map(user => (
                                                        <option value={user.username}>{user.firstname} {user.lastname}</option>
                                                    ))}
                                                </select> <i></i> 
                                            </label>
                                        </section>
                                    </div>
                                    <div className="col-xs-12 col-md-8">
                                        <label className="label col col-5 text-right">Credit: </label>
                                        <section className="col col-7">
                                            <input className="form-control" type="number" min="0" step="any" id="cashlimit" name="cashlimit" value={formItems.cashlimit} />
                                        </section>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button id="btnCashiercancel" type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
                            <button type="submit" form="frmCashier" className="btn btn-primary">Save Cashier</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}